import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ShieldCheck, Heart, Target, Award } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function About() {
  return (
    <div>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid lg:grid-cols-2 gap-12 items-center">
        <motion.div initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.6 }}>
          <p className="text-xs uppercase tracking-[0.18em] text-blue-800 dark:text-blue-400 font-semibold mb-3">About T5 Care Service</p>
          <h1 className="font-display text-4xl lg:text-5xl font-bold text-blue-950 dark:text-blue-50 leading-tight">Care that feels like family, backed by professional standards</h1>
          <p className="mt-5 text-lg text-slate-600 dark:text-slate-300 leading-relaxed">Based at 5310 E. Main St in Columbus, Ohio, T5 Care Service is a state-approved home care provider under the Ohio Department of Aging PASSPORT program. We exist to keep Ohio seniors safe, independent, and cared for in the place they love most — home.</p>
          <p className="mt-4 text-slate-600 dark:text-slate-300 leading-relaxed">Today we're expanding that mission into a full industry platform: a marketplace connecting families with verified caregivers, and an academy of courses and digital products that raise the standard of care across the state.</p>
          <Button asChild className="mt-7 h-12 px-7 bg-blue-900 hover:bg-blue-950 text-white"><Link to="/contact" data-testid="about-contact-button">Get in touch</Link></Button>
        </motion.div>
        <motion.img initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.7 }}
          src="https://images.unsplash.com/photo-1559234938-b60fff04894d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" alt="Seniors enjoying independence" className="rounded-3xl shadow-2xl w-full object-cover aspect-[4/3.5]" />
      </section>

      <section className="bg-[#E8F0EC] dark:bg-blue-900/40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid md:grid-cols-4 gap-6">
          {[
            { icon: ShieldCheck, title: "State Approved", desc: "Ohio Dept of Aging PASSPORT & Medicaid Waiver certified." },
            { icon: Heart, title: "Compassion First", desc: "Every caregiver is chosen for empathy as much as skill." },
            { icon: Target, title: "10x Vision", desc: "Building the go-to platform for Ohio's home care industry." },
            { icon: Award, title: "Professional", desc: "Licensed nursing supervision and ongoing training." },
          ].map((v, i) => (
            <motion.div key={v.title} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.08 }}
              className="bg-white dark:bg-blue-900/50 rounded-2xl p-7 shadow-sm">
              <v.icon className="w-9 h-9 text-blue-800 dark:text-blue-300 mb-4" />
              <h3 className="font-display text-lg font-semibold text-blue-950 dark:text-blue-50">{v.title}</h3>
              <p className="mt-2 text-sm text-slate-600 dark:text-slate-300 leading-relaxed">{v.desc}</p>
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
}
